module.exports = __webpack_public_path__ + "img/default.114f81a4.png";